import React from 'react';
import { useCompanyContext } from '../../contexts/Company';
import Header from '../misc/Header';
import NoContent from '../misc/Message';
import PlansTable from './PlansTable';
import Disclaimer from './Disclaimer';

export default function Layout({ plans, setPlans, deletePlan, setLoading }) {
  const { business } = useCompanyContext();
  const companyName = business?.name ? `${business.name} ` : '';

  return (
    <React.Fragment>
      <Header header={companyName + 'Growth Plans'} />
      {plans.length === 0 && (
        <NoContent text="It looks like you don't have any Growth Plans yet. You can submit a Growth Plan on the Lines page." />
      )}
      {plans.length > 0 && (
        <>
          <Disclaimer />
          <PlansTable
            plans={plans}
            setPlans={setPlans}
            deletePlan={deletePlan}
            setLoading={setLoading}
          />
        </>
      )}
    </React.Fragment>
  );
}
